module.exports = __webpack_public_path__ + "img/mn.cfb1b2e5.svg";